// extracted by mini-css-extract-plugin
export default {"pageLayout":"xa-z","mainContent":"ya-z","activeSidebar":"za-z"};